import type { AuditCategory } from '@/api/audit/auditApi.types';

export const ALL_ACTIVITY_CATEGORIES = 'all';

export type ActivityCategoryFilter = AuditCategory | typeof ALL_ACTIVITY_CATEGORIES;

export const ACTIVITY_CATEGORY_FILTERS: ActivityCategoryFilter[] = [
  ALL_ACTIVITY_CATEGORIES,
  'access',
  'change',
  'authentication',
];

export const CLIENT_ACCESS_HISTORY_PREVIEW_SIZE = 5;

export const ACTIVITY_LOG_TAB_QUERY_VALUE = 'activity';
export const ACTIVITY_LOG_TAB_QUERY_PARAMETER = 'tab';
export const ACTIVITY_LOG_CLIENT_QUERY_PARAMETER = 'client';

export const SIGN_IN_FAILED_ACTION = 'auth.sign_in_failed';
